<template>
  <div class="absolute top-0 flex justify-center mt-12" :style="style">
    <div class="w-full md:w-1/2 bg-white rounded-lg border">
      <div class="border border-t-0 border-l-0 border-r-0 flex items-center px-2 py-2">
        <i class="material-icons p-0 m-0 bg-successf"> search </i>
        <input v-model.trim="search" class="w-full border-0 rounded-lg h-8 px-2" type="text" placeholder="Buscar..." />
      </div>
      <div class="px-1 py-3 overflow-auto" style="height: 250px">
        <div
          class="flex items-start border border-t-0 border-l-0 border-r-0 py-2 px-2 last-item"
          v-for="(question, j) in filterQuestions"
          :key="j"
        >
          <vs-radio v-model="radios1" :vs-value="question"></vs-radio>
          <div class="flex flex-col">
            <span class="font-bold">{{ question.name }}</span>
            <span>{{ question.label }}</span>
          </div>
        </div>
      </div>
      <div class="flex justify-end py-2 border border-t border-l-0 border-r-0 border-b-0">
        <vs-button color="danger" type="border" @click="$emit('update:active', false)">Cancelar</vs-button>
        <vs-button class="ml-3 mr-3" color="success" type="border" :disabled="radios1 === null" @click="addQuestion"
          >Aceptar</vs-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import {
  createDependence,
  createDependenceCompound,
  getDependencies,
  getDadQuestion
} from "@/serviforms/designer/indexDB/dependencies";

import { getAllQuestion, setQuestion } from "@/serviforms/designer/indexDB/logic.js";

export default {
  async mounted() {
    const itemsQuestion = document.querySelector(`#items-question_${this.indexQuestion}`);
    this.style.width = `${itemsQuestion.getBoundingClientRect().width}px`;
    this.style.display = "block";
    const questions = await this.getQuestionsDad();
    const dependencies = await this.getDependencies();
    this.ListQuestions = await this.matchQuestions(questions, dependencies);
  },
  data() {
    return {
      ListQuestions: [],
      search: "",
      radios1: null,
      RuleOutType: ["label", "video", "map", "viewer", "subform", "datasource", "signature", "geo", "file", "date"],
      RuleOutInputType: ["multiInput", "checktext", "url", "QRGen", "scala", "flex"],
      style: {
        // width: "0px",
        zIndex: "1000000",
        display: "none"
      }
    };
  },
  methods: {
    /**
     * Obtiene las preguntas hijas para una relación de tipo compound
     */
    async getDependencies() {
      const { compound } = await getDependencies();
      const getSelf = compound[this.questionDad.name] || false;

      if (getSelf) {
        const getSelfCompound = getSelf.answers || false;
        if (getSelfCompound.length > 0) {
          return getSelfCompound.map(question => question.name);
        }
      }
      return [];
    },
    /**
     * Obtiene un array de preguntas ascendentes para la relación de tipo compound
     */
    async getQuestionsDad() {
      const result = await getAllQuestion();
      const index = result.findIndex(question => question.name === this.questionDad.name);
      return result.slice(0, index);
    },
    /**
     * Obtiene una lista de preguntas que aún no tengan una relación de tipo compound
     * @param {array<question>} questions - Lista de preguntas ascendentes
     * @param {array<string>} dependencies - Lista de ids de la preguntas ascendentes (P_x).
     */
    async matchQuestions(questions, dependencies) {
      return questions.filter(question => !dependencies.includes(question.name));
    },
    /**
     * Agrega un array de preguntas hijas para crear la dependencia en la pregunta padre.
     */
    addQuestion() {
      this.radios1.isSelected = true;
      this.$emit("question", this.radios1);
      this.$emit("update:active", false);
    }
  },
  computed: {
    ...mapState("resource", ["indexQuestion", "questionsByPage"]),
    /**
     * Obtiene la pregunta padre sobre la qwue se le va a agregar las dependencias.
     */
    questionDad() {
      return this.questionsByPage[this.indexQuestion];
    },
    /**
     * Realiza un filtro sobre aquellas preguntas hijas que pueden ser agregadas a la dependencia compuesta.
     */
    filterByType() {
      return this.ListQuestions.filter(question => {
        return !this.RuleOutType.includes(question.type) && !this.RuleOutInputType.includes(question.inputType);
      });
    },
    /**
     * Obtiene una lista de preguntas filtradas por el id ó label de la pregunta.
     */
    filterQuestions() {
      return this.filterByType.filter(question => {
        if (this.search.length > 0) {
          const name = question.name.toLowerCase().includes(this.search.toLowerCase());
          const label = question.label.toLowerCase().includes(this.search.toLowerCase());
          return name || label;
        }
        return true;
      });
    },
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    }
  },
  watch: {
    isSmallerScreen(value) {
      const itemsQuestion = document.querySelector(`#items-question_${this.indexQuestion}`);
      this.style.width = `${itemsQuestion.getBoundingClientRect().width}px`;
    }
  }
};
</script>

<style lang="scss" scoped>
.last-item:last-child {
  border: none !important;
  padding-bottom: 0px !important;
}
</style>
